import { Component, Input, Inject } from '@angular/core';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-generate-registration-code',
    templateUrl: './side-effect-generate-registration-code.component.html',
    standalone: false
})
export class SideEffectGenerateRegistrationCodeComponent {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.userIdSource = this._seConfiguration.userIdSource || '';
        this._seConfiguration.codeTarget = this._seConfiguration.codeTarget || '';

    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }
}
